import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { CarFeatureConfig } from '../../../types/insurances/CarFeatureConfig';
import { car as base } from './base';
import { car as AT } from './AT';
import { car as CZ } from './CZ';
import { car as HR } from './HR';
import { car as SK } from './SK';

export const carConfig: InsuranceIndex<CarFeatureConfig> = { base, AT, CZ, HR, SK };
